import { render } from "./GroupAlarmConfigurationReport.vue?vue&type=template&id=59280a61"
import script from "./GroupAlarmConfigurationReport.vue?vue&type=script&lang=js"
export * from "./GroupAlarmConfigurationReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__